import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-none border-0 border-b border-[#E5E7EB] bg-transparent px-0 py-2 text-sm text-[#101828] placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-[#163381] disabled:cursor-not-allowed disabled:opacity-50 transition-colors",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
